var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',_vm._g(_vm._b({ref:"myupload",attrs:{"on-error":_vm.onError,"before-upload":_vm.beforeUpload,"on-success":_vm.onSuccess},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,slotName){return {key:slotName,fn:function(){return [_vm._t(slotName)]},proxy:true}})],null,true)},'el-upload',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }